import React from 'react';

import type { TicketInfo } from '../../../../../types/Cashier';

import { wrapper } from './TicketSetRecord.scss';

interface Props {
  ticketSet?: TicketInfo[];
}

const TicketSetRecord: React.FC<Props> = ({ ticketSet }) => (
  <ul className={wrapper}>
    {ticketSet?.map(({ numOfTickets, ticketName }, index) => (
      <li key={index}>{`${numOfTickets} * ${ticketName}`}</li>
    ))}
  </ul>
);

export default TicketSetRecord;
